module.exports = __webpack_public_path__ + "static/media/fondoheader.22a634ce.png";